import { Component } from '@angular/core';
import { EnrollmentFacade } from '@features/enrollment/facades/enrollment.facade';
import { AuthFacade } from '@rd/core/auth/store/facades/auth.facade';
import { LocaleFacade } from '@rd/core/facades/locale-facade/locale.facade';
import { LoyaltyCurrencyFacade } from '@rd/core/facades/loyalty-currency-facade/loyalty-currency.facade';
import { UnleashFacade } from '@rd/core/facades/unleash-facade/unleash-facade.ts';
import { isNotNull } from '@rd/utils/isNotNull';
import { combineLatest, iif, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { RewardsProgramsViewFacade } from './rewards-program/views/facade/rewards-program-view.facade';

@Component({
  selector: 'bnz-root',
  styles: [
    `
      .spinner-container {
        height: 100vh;
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .rd-shared-spinner {
        height: 60px;
      }

      bnz-desktop-header {
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 2;
        background: #f5f5f5;
      }
    `,
  ],
  templateUrl: 'app.component.html',
  standalone: false,
})
export class BnzAppComponent {
  isReady$ = combineLatest([
    this.localeFacade.selectedLocale$,
    this.loyaltyCurrencyFacade.getLoyaltyCurrencySelected$.pipe(
      filter(isNotNull),
    ),
    this.authFacade.authRenderState$.pipe(
      filter((loggedInState) => loggedInState !== 'loading'),
      switchMap((loggedInState) => {
        if (loggedInState === 'loggedIn') {
          return this.rewardsProgramViewFacade.selectedScheme$.pipe(
            filter(isNotNull),
          );
        }
        return of(true);
      }),
    ),
    this.authFacade.authRenderState$.pipe(
      filter((loggedInState) => loggedInState !== 'loading'),
      switchMap((loggedInState) =>
        iif(
          () => loggedInState === 'loggedIn',
          this.enrollmentFacade.loadEnrollmentsLoading$.pipe(
            map((isEnrollmentsLoading: boolean) => !isEnrollmentsLoading),
          ),
          of(true),
        ),
      ),
    ),
    this.unleashFacade.isUnleashClientReady$,
  ]).pipe(map((v) => v.every(Boolean)));

  constructor(
    private localeFacade: LocaleFacade,
    private loyaltyCurrencyFacade: LoyaltyCurrencyFacade,
    private rewardsProgramViewFacade: RewardsProgramsViewFacade,
    private enrollmentFacade: EnrollmentFacade,
    private authFacade: AuthFacade,
    private unleashFacade: UnleashFacade,
  ) {}
}
